export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8124.a020a2fb.jpg";